import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/jh-ui';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

export type DiscardChangesConfirmationData = { comments: string };

const tagName = 'tm-bo-discard-changes-confirmation';
@customElement(tagName)
export class DiscardChangesConfirmation extends TmBaseComponent {
    public static get title() {
        return 'Discard Company User Changes';
    }

    public render() {
        return html`<div>
            <div>Are you sure you would like to discard your changes?</div>
            <tm-input
                data-testid="comment-input"
                @input=${(e: InputEvent) => this.handleCommentChange(e)}
                no-resize
                class="mt-5"
                type="textarea"
                rows="12"
                label="Comments:"
            ></tm-input>
        </div>`;
    }

    private async handleCommentChange(e: InputEvent) {
        this.dispatchEvent(
            new CustomEvent('comment-change', { detail: (e.target as HTMLInputElement).value })
        );
    }

    public static get styles() {
        return css`
            :host {
                --jh-size-1200: 12rem;
            }
        `;
    }
}
